export default __webpack_public_path__ + "static/media/fire.f8761e8d.jpg";